<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item">
        <a href="javascript:;">商城资金管理</a>
      </li>
      <li class="breadcrumb-item active">资金管理</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      商城资金管理
      <small>会员提现以及会员资金统计...</small>
    </h1>
    <!-- end page-header -->
    <panel title="会员佣金提取明细">
      <Row :gutter="5">
        <Col span="5">
          <Input v-model="filterCond.username" placeholder="会员名称"></Input>
        </Col>
        <Col span="5">
          <Select v-model="filterCond.status">
            <Option :value="99" label="不限制"></Option>
            <Option :value="0" label="未处理"></Option>
            <Option :value="1" label="已处理"></Option>
          </Select>
        </Col>
        <Col span="4">
          <DatePicker v-model="filterCond.begindate" placeholder="申请开始日期"></DatePicker>
        </Col>
        <Col span="4">
          <DatePicker v-model="filterCond.enddate" placeholder="申请结束日期"></DatePicker>
        </Col>
        <Col span="3">
          <Button type="primary" class="btn btn-theme" @click="fn_query">查询</Button>
        </Col>
      </Row>
      <Table :columns="columns" :data="datas" class="m-t-10">
        <template slot="name" slot-scope="{row}">{{row.user.name}}</template>
        <template slot="logo" slot-scope="{row}">
          <img :src="row.user.portrait" style="max-width:60px" />
        </template>

        <template slot="actiontype" slot-scope="{row}">
          <span v-if="row.actiontype =='balance'">转余额</span>
          <span v-else-if="row.actiontype == 'cash'">转现金</span>
        </template>

        <template slot="status" slot-scope="{row}">
          <span v-if="row.status ==0">未处理</span>
          <span v-else-if="row.status == 1" style="color:blue">
            <i class="fa fa-check"></i> 已处理
          </span>
        </template>

        <template slot="action" slot-scope="{row}">
          <button
            type="button"
            class="btn btn-theme m-r-5"
            v-if="row.status == 0"
            @click="fn_withdraw_order(row)"
          >转账</button>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="filterCond.page"
        :page-size="filterCond.pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
  </div>
</template>
<script>
import { getMemberWithdrawOrderList, withdrawFundsData } from "@/api/members";
import moment from "moment";
export default {
  data() {
    return {
      columns: [
        {
          title: "#ID",
          key: "id",
          width: 50
        },
        {
          title: "名称",
          slot: "name",
          width: 180
        },
        {
          title: "头像",
          slot: "logo",
          width: 100
        },

        {
          title: "类型",
          slot: "actiontype",
          width: 100
        },
        {
          title: "佣金",
          key: "amount",
          width: 100
        },

        {
          title: "状态",
          slot: "status",
          width: 180
        },
        {
          title: "申请时间",
          key: "created_at",
          width: 180
        },
        {
          title: "提现处理日期",
          key: "withdrawtime",
          width: 180
        },

        {
          title: "操作",
          slot: "action"
        }
      ],
      datas: [],
      totalRows: 0,

      v_show: false,
      filterCond: {
        page: 1,
        pageNum: 10,
        username: "",
        status: 0
      }
    };
  },
  mounted() {
    this.fn_load(this.filterCond);
  },
  methods: {
    fn_query() {
      this.filterCond.begindate = moment(this.filterCond.begindate).format(
        "YYYY-MM-DD"
      );
      this.filterCond.enddate = moment(this.filterCond.enddate).format(
        "YYYY-MM-DD"
      );

      this.fn_load(this.filterCond);
    },
    fn_load(filterCond) {
      getMemberWithdrawOrderList(filterCond)
        .then(res => {
          this.datas = res.data.data;
          this.totalRows = res.data.total;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_switchPage(page) {
      this.filterCond.page = page;
      this.fn_load(this.filterCond);
    },
    fn_withdraw_order(row) {
      //从企业账户余额里转账
      withdrawFundsData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.error({
              title: "失败",
              desc: res.data.message
            });
            row.status = 1;
          } else {
            this.$Notice.error({
              title: "失败",
              desc: res.data.message
            });
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>